import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface SettingsGroupProps {
  children: ReactNode;
  title?: string;
  translationKey?: string;
}

/**
 * iOS 风格的设置组组件
 */
export const SettingsGroup: React.FC<SettingsGroupProps> = ({
  children,
  title,
  translationKey,
}) => {
  const { t } = useTranslation(['v3/me']);

  // 如果提供了翻译键，使用翻译，否则使用传入的标题
  const displayTitle = translationKey ? t(translationKey) : title;

  return (
    <div className="mb-6">
      {displayTitle && (
        <h2 className="text-ios-footnote uppercase font-semibold text-ios-gray dark:text-ios-dark-gray px-4 mb-1">
          {displayTitle}
        </h2>
      )}

      <div className="bg-white dark:bg-ios-dark-gray6 rounded-ios-lg overflow-hidden border border-ios-gray5 dark:border-ios-dark-gray5 shadow-ios dark:shadow-ios-dark divide-y divide-ios-gray5 dark:divide-ios-dark-gray5">
        {children}
      </div>
    </div>
  );
};
